import Vue from 'vue'
const isBrowser = typeof window !== 'undefined'

const toastOptions = {
  duration: 5000,
  position: 'bottom-right',
  iconPack: 'mdi',
  closeOnSwipe: true,
  keepOnHover: true,
  action: {
    text: '',
    class: 'toast-dismiss',
    onClick: (e, toastObject) => {
      toastObject.goAway(0)
    },
  },
}

export default {
  success(message, options) {
    this.print('success', message, options)
  },
  error(message, options) {
    this.print('error', message, options)
  },
  warning(message, options) {
    this.print('warning', message, options)
  },
  info(message, options) {
    this.print('info', message, options)
  },
  show(message, options) {
    this.print('show', message, options)
  },
  debug(message, options) {
    this.print('debug', message, options)
  },
  clear() {
    Vue.prototype.$toasted.clear()
  },
  print(kind, message, options) {
    if (!options) {
      options = toastOptions
    }

    if (isBrowser) {
      if (kind === 'success') {
        options.icon = 'check'
        options.type = 'success'
        Vue.prototype.$toasted.success(message, options)
      } else if (kind === 'error') {
        options.icon = 'alert'
        options.type = 'error'
        Vue.prototype.$toasted.error(message, options)
      } else if (kind === 'info') {
        options.icon = 'information'
        options.type = 'info'
        Vue.prototype.$toasted.info(message, options)
      } else if (kind === 'debug') {
        options.icon = 'wrench'
        options.type = 'info'
        Vue.prototype.$toasted.show(message, options)
      } else if (kind === 'warning') {
        options.icon = 'alert'
        Vue.prototype.$toasted.warning(message, options)
      } else if (kind === 'show') {
        Vue.prototype.$toasted.show(message, options)
      }
    }
  },
}
